import React from 'react'

const TextAreaJSX = ({ labelText, nameValue, onChange, value, maxLength, splithalf, showWordCount }) => {
    return (
        <>
            <div className={`col-md-${splithalf ? 6 : 12} mt-2`}>
                <div className='ms-2'>
                    <label htmlFor="" className='form-label  mb-0'>
                        {labelText} {showWordCount ? <>(Character Remaining:{maxLength - (value ? value.length : 0)}/{maxLength}) </> : null}
                    </label>
                    <div className="icon-forms mb-3 mb-sm-0">
                        <textarea
                            type="text"
                            className="form-control"
                            id={`${nameValue}`}
                            name={`${nameValue}`}
                            value={value}
                            onChange={onChange}
                            maxLength={maxLength ? maxLength : 5000}
                        // onBlur={formik.handleBlur}
                        ></textarea>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TextAreaJSX